import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pOturumAc, rKullanici, rValue } from '../../models/.catalog';

export default class OturumAcApi extends ApiBase<pOturumAc, rValue<rKullanici>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OturumAc',
      }),
      options
    );
    this._ServiceUrl = '/services/Kullanici.asmx';
  }
}
